export const SET_LANGUAJE = "SET_LANGUAJE";
export const SET_THEME = "SET_THEME";
